// import env from '@/utils/env.js';
// import editCarInfoState from '@/pages/edit-car-info/state';
// import driverComplainState from '@/pages/car-complain/state';
// import state from '@/store/ownerRegistrationState';
// import GuideLineComp from '@/business-components/guideline';
// import drivApplyApi from '@/api/drivApply';

const drivApplyRoutes = [
  {
    path: '/choose-car-model-v2',
    name: 'choose-car-model-v2',
    meta: { title: '选择车型' },
    component: () => import(/* webpackChunkName: "owner-registration-base" */'@/pages/choose-car-model-v2/index'),
  },
  // 完整版认证引导页
  {
    path: '/update-app-version',
    name: 'update-app-version',
    meta: { title: '下载最新版本APP' },
    component: () => import(/* webpackChunkName: "update-app-version" */'@/pages/update-app-version/index'),
  },
  {
    path: '/choose-city',
    name: 'choose-city',
    meta: { title: '选择城市' },
    component: () => import(/* webpackChunkName: "owner-registration" */'@/pages/choose-city/index'),
    beforeEnter: async (to, from, next) => {
      // eslint-disable-next-line no-param-reassign
      to.meta.fromPageName = from.name;
      next();
    },
  },
  // 车主认证-状态分发页面
  {
    path: '/audit',
    name: 'audit',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-base" */ '@/pages/audit/index'),
  },
  // 车主认证-版本分发页面
  {
    path: '/driver-register',
    meta: { title: '车主认证' },
    name: 'driver-register',
    component: () => import(/* webpackChunkName: "owner-registration-base" */ '@/pages/driver-register/Index'),
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line no-param-reassign
      to.meta.showModal = false;
      if (from.meta && from.meta.showModalWhenBack) {
        // eslint-disable-next-line no-param-reassign
        to.meta.showModal = true;

        let version = 1; // '精简版';
        if (from.name === 'driver-authentication/personal-info') {
          version = 3; // '后置版';
        } else if (from.name === 'owner-registration') {
          version = 2; // '完整版';
        }
        // eslint-disable-next-line no-param-reassign
        to.meta.version = version;
      }
      next();
    },
  },
  // 编辑车辆
  {
    path: '/edit-car-info',
    name: 'edit-car-info',
    meta: { title: '更换车辆', sourceType: 4 },
    component: () => import(/* webpackChunkName: "edit-car-info" */ '@/pages/edit-car-info/index'),
    beforeEnter: async (to, from, next) => {
      const { default: drivApplyApi } = await import('@/api/drivApply');
      const _bizScene = to.query.bizScene || 'HITCH_NORMAL';
      const data = await drivApplyApi.getDirverRegisterRecord({
        bizScene: _bizScene,
      });
      const {
        registerRecordList: [
          registerRecordData = {},
        ] = [],
      } = data || {};
      const {
        bizScene = _bizScene, applyMethod,
        cityInfo: { cityCode, cityName } = {},
      } = registerRecordData;
      // eslint-disable-next-line no-param-reassign
      to.meta.bizScene = bizScene;
      // eslint-disable-next-line no-param-reassign
      to.meta.applyMethod = applyMethod;
      // eslint-disable-next-line no-param-reassign
      to.meta.cityCode = cityCode;
      // eslint-disable-next-line no-param-reassign
      to.meta.cityName = cityName;
      const isFromChooseCarModel = from.name === 'choose-car-model-v2';
      // eslint-disable-next-line no-param-reassign
      to.meta.isFromChooseCarModel = isFromChooseCarModel;
      if (!isFromChooseCarModel) {
        const { default: editCarInfoState } = await import('@/pages/edit-car-info/state');
        await editCarInfoState.init(bizScene);
      }
      next();
    },
    children: [
      {
        path: 'edit',
        meta: { title: '更换车辆', sourceType: 4 },
        name: 'edit-car-info/edit',
        component: () => import(/* webpackChunkName: "edit-car-info" */ '@/pages/edit-car-info/edit'),
      },
      {
        path: 'status',
        meta: { title: '更换车辆', sourceType: 4 },
        name: 'edit-car-info/status',
        component: () => import(/* webpackChunkName: "edit-car-info" */ '@/pages/edit-car-info/status'),
      },
      {
        path: 'choose-car-model',
        name: 'edit-car-info/choose-car-model',
        meta: { title: '选择车型', sourceType: 4 },
        component: () => import(/* webpackChunkName: "edit-car-info" */ '@/pages/edit-car-info/choose-car-model'),
      },
      {
        path: '',
        redirect: 'edit',
      },
    ],
  },
  // 车主申诉
  {
    path: '/car-complain',
    name: 'car-complain',
    meta: { title: '申诉并找回车辆' },
    component: () => import(/* webpackChunkName: "car-complain" */ '@/pages/car-complain/index'),
    beforeEnter: async (to, from, next) => {
      const isFromChooseCarModel = from.name === 'choose-car-model-v2';
      // eslint-disable-next-line no-param-reassign
      to.meta.isFromChooseCarModel = isFromChooseCarModel;
      if (!isFromChooseCarModel) {
        const { default: driverComplainState } = await import('@/pages/car-complain/state');
        await driverComplainState.init(from.meta.sourceType);
      }
      next();
    },
    children: [
      {
        path: 'complain',
        meta: { title: '申诉并找回车辆' },
        name: 'car-complain/complain',
        component: () => import(/* webpackChunkName: "car-complain" */ '@/pages/car-complain/complain'),
      },
      {
        path: 'success',
        meta: { title: '申诉并找回车辆' },
        name: 'car-complain/success',
        component: () => import(/* webpackChunkName: "car-complain" */ '@/pages/car-complain/success'),
      },
      {
        path: 'choose-car-model',
        name: 'car-complain/choose-car-model',
        meta: { title: '选择车型' },
        component: () => import(/* webpackChunkName: "car-complain" */ '@/pages/car-complain/choose-car-model'),
      },
      {
        path: '',
        redirect: 'complain',
      },
    ],
  },
  // 车主认证-完整版
  {
    path: '/owner-registration',
    name: 'owner-registration',
    meta: { title: '车主认证', showModalWhenBack: true, sourceType: 3 },
    component: () => import(/* webpackChunkName: "owner-registration-overall" */ '@/pages/update-app-version/index'),
    beforeEnter: async (to, from, next) => {
      const isFromChooseCarModel = from.name === 'choose-car-model-v2';
      // eslint-disable-next-line no-param-reassign
      to.meta.isFromChooseCarModel = isFromChooseCarModel;
      next();
    },
  },
  // 车主认证-完整版-提交成功页面
  {
    path: '/owner-registration-success',
    name: 'owner-registration-success',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-overall" */ '@/pages/owner-registration/owner-registration-success/index'),
  },
  // 车主认证-完整版-小程序
  {
    path: '/owner-registration-alipay',
    name: 'owner-registration-alipay',
    meta: { title: '车主认证', showModalWhenBack: true, sourceType: 3 },
    component: () => import(/* webpackChunkName: "owner-registration-overall" */ '@/pages/update-app-version/index'),
  },
  // 车主认证-精简版
  {
    path: '/owner-registration-simple',
    name: 'owner-registration-simple',
    meta: { title: '车主认证', showModalWhenBack: true, sourceType: 2 },
    component: () => import(/* webpackChunkName: "owner-registration-simple" */ '@/pages/update-app-version/index'),
    beforeEnter: async (to, from, next) => {
      const isFromChooseCarModel = from.name === 'choose-car-model-v2';
      // eslint-disable-next-line no-param-reassign
      to.meta.isFromChooseCarModel = isFromChooseCarModel;
      next();
    },
  },
  // owner-registration-outside 废弃 端外车主认证
  {
    path: '/owner-registration-outside',
    name: 'owner-registration-outside',
    meta: { title: '车主认证', showModalWhenBack: true, sourceType: 2 },
    component: () => import(/* webpackChunkName: "owner-registration-outside" */ '@/pages/update-app-version/index'),
  },
  // owner-registration-outside 废弃 端外成功页
  {
    path: '/owner-registration-outside-success',
    name: 'owner-registration-outside-success',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-outside" */ '@/pages/owner-registration/owner-registration-success/outside-index'),
  },
  // 车主认证-完整版
  {
    path: '/owner-registration-success-v2',
    name: 'owner-registration-success-v2',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-overall" */ '@/pages/owner-registration/owner-registration-success/index-v2'),
    beforeEnter: async (to, from, next) => {
      const { default: GuideLineComp } = await import('@/business-components/guideline');
      GuideLineComp('bottom');
      next();
    },
  },
  // 车主认证-后置版
  {
    path: '/driver-authentication',
    name: 'driver-authentication',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/Index'),
    beforeEnter: async (to, from, next) => {
      // driver-authentication的mounted有个认证逻辑，需要排除一些页面跳转
      // 车型选择页面 + 申诉页面 + 车主认证成功
      const shouldNoMount = from.name === 'choose-car-model-v2'
        || from.name === 'ride-hailing-material-supplement'
        || from.name === 'ride-hailing-material-supplement-success'
        || from.name === 'car-complain/complain'
        || from.name === 'driver-authentication/submit-success';
      // eslint-disable-next-line no-param-reassign
      to.meta.shouldNoMount = shouldNoMount;
      try {
        if (!shouldNoMount) {
          const { default: state } = await import('@/store/ownerRegistrationState');
          await state.init();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
      next();
    },
    children: [
      {
        path: 'personal-info',
        meta: { title: '车主认证', showModalWhenBack: true, sourceType: 1 },
        name: 'driver-authentication/personal-info',
        component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/PersonalInfo'),
      },
      {
        path: 'alipay-auth',
        meta: { title: '实名认证', showModalWhenBack: true, sourceType: 1 },
        name: 'driver-authentication/alipay-auth',
        component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/AliPayAuth'),
      },
      {
        path: 'car-info',
        meta: { title: '车主认证', showModalWhenBack: true, sourceType: 1 },
        name: 'driver-authentication/car-info',
        component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/CarInfo'),
      },
      {
        path: 'choose-car-model',
        meta: { title: '选择车型' },
        name: 'driver-authentication/choose-car-model',
        component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/ChooseCarModel'),
      },
      {
        path: 'submit-success',
        meta: { title: '车主认证' },
        name: 'driver-authentication/submit-success',
        component: () => import(/* webpackChunkName: "owner-registration-post" */ '@/pages/driver-authentication/SubmitSuccess'),
        beforeEnter: async (to, from, next) => {
          const { default: GuideLineComp } = await import('@/business-components/guideline');
          GuideLineComp();
          next();
        },
      },
    ],
  },
  // 车主认证测试
  {
    path: '/mock-index',
    meta: { title: '车主认证' },
    name: 'mock-index',
    component: () => import(/* webpackChunkName: "owner-registration-test" */ '@/pages/driv-apply/driv-apply-simplified/pages/mockIndex'),
  },
  // 注册成功页面
  {
    path: '/register-success',
    meta: { title: '车主认证' },
    name: 'register-success',
    component: () => import(/* webpackChunkName: "owner-registration-base" */ '@/pages/driver-authentication/RegisterSubmitSuccess.vue'),
  },
  // 车主认证-极速版
  {
    path: '/driv-apply-simplified',
    name: 'driv-apply-simplified',
    meta: { title: '车主认证' },
    component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/index'),
    beforeEnter: async (to, from, next) => {
      const isFromChooseCarModel = from.name === 'choose-car-model-v2';
      // eslint-disable-next-line no-param-reassign
      to.meta.isFromChooseCarModel = isFromChooseCarModel;
      next();
    },
    children: [
      {
        path: 'submit-success',
        meta: { title: '车主认证' },
        name: 'driv-apply-simplified/submit-success',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driver-authentication/SubmitSuccess.vue'),
        beforeEnter: async (to, from, next) => {
          const { default: GuideLineComp } = await import('@/business-components/guideline');
          GuideLineComp();
          next();
        },
      },
      {
        path: 'basic-info-no-pic',
        meta: { title: '车主认证', sourceType: 6 },
        name: 'driv-apply-simplified/basic-info-no-pic',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/pages/basicInfoNoPic/basicInfoNoPic'),
      },
      {
        path: 'basic-info-with-pic',
        meta: { title: '车主认证', sourceType: 5 },
        name: 'driv-apply-simplified/basic-info-with-pic',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/pages/basicInfoWithPic/basicInfoWithPic'),
      },
      {
        path: 'add-driv-info',
        meta: { title: '车主认证' },
        name: 'driv-apply-simplified/add-driv-info',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/pages/addDrivInfo/addDrivInfo'),
      },
      {
        path: 'add-driver-info',
        meta: { title: '车主认证' },
        name: 'driv-apply-simplified/add-driv-info-real',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/pages/addDrivInfo/addDrivInfoRealPage'),
      },
      {
        path: 'detain-page',
        meta: { title: '车主认证' },
        name: 'driv-apply-simplified/detain-page',
        component: () => import(/* webpackChunkName: "owner-registration-fast" */ '@/pages/driv-apply/driv-apply-simplified/pages/detainPage'),
      },
    ],
  },
  // 端外认证集合页
  {
    path: '/driv-apply-outside-aggregated-index',
    meta: { title: '注册哈啰车主' },
    name: 'driv-apply-outside-aggregated-index',
    component: () => import(/* webpackChunkName: "driv-apply-outside-aggregated-index" */ '@/pages/driv-apply/outside-aggregated-index'),
  },
  // 完善认证材料页
  {
    path: '/ride-hailing-material-supplement',
    meta: { title: '完善认证材料' },
    name: 'ride-hailing-material-supplement',
    component: () => import(/* webpackChunkName: "ride-hailing-material-supplement" */ '@/pages/driv-apply/ride-hailing-material-supplement/index'),
  },
  // 完善认证材料页成功页
  {
    path: '/ride-hailing-material-supplement-success',
    meta: { title: '材料补充成功' },
    name: 'ride-hailing-material-supplement-success',
    component: () => import(/* webpackChunkName: "ride-hailing-material-supplement" */ '@/pages/driv-apply/ride-hailing-material-supplement/success.vue'),
  },
];

export default drivApplyRoutes;
